module.exports = __webpack_public_path__ + "img/63.aa1b8e19.png";